import "./AreYouSure.css";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { setAreYouSureVisible } from "../../../store/modals/modalActions";

interface AreYouSureProps {
  callback: () => void;
}

const AreYouSure = ({ callback }: AreYouSureProps) => {
  const dispatch = useDispatch();
  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
      border: 0,
      boxShadow: "1px 0px 19px -4px rgba(0, 0, 0, 0.3)",
      height: 300,
      width: window.innerWidth > 480 ? "50%" : "75vw",
    },
  };

  const onYesClicked = () => {
    callback();
    dispatch(setAreYouSureVisible(false));
  };

  const onNoClicked = () => dispatch(setAreYouSureVisible(false));

  return (
    <Modal isOpen={true} style={modalStyle} ariaHideApp={false}>
      <div className="are-you-sure-container">
        <p className="are-you-sure-heading">
          Are you sure you want to save your changes?
        </p>
        <p className="are-you-sure-subheading">
          Saving will log you out and you'll be required to verify the new email
          address entered.
        </p>
        <div className="are-you-sure-button-container">
          <div className="yes-button" onClick={() => onYesClicked()}>
            Yes, I'm sure
          </div>
          <div className="no-button" onClick={() => onNoClicked()}>
            No
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AreYouSure;
